import environments from '@utils/environments';
import mixpanel from 'mixpanel-browser';

export function trackUserProfile($name: string, $email: string) {
  const userProperties = { $name, $email };
  try {
    mixpanel.people.set(userProperties);
  } catch (_) {
    if (environments.isDev() || environments.isLocal()) {
      console.group('mixpanel.people.set', { userProperties });
      console.groupEnd();
    }
  }
}
